import '@tamagui/core/reset.css'

import { Button, Form, Input, Checkbox, TamaguiProvider, YStack } from 'tamagui'
import { LinearGradient } from 'tamagui/linear-gradient'
import { BrowserRouter, Route, Routes, useNavigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { Header } from './components/Header'

import config from './tamagui.config'

import { Home as PublicHome } from './pages/public/Home'
import { Login } from './pages/public/Login'
import { Register } from './pages/public/Register'
import { Home as ManageHome } from './pages/manage/Home'
import { CreateOrganization, ManageOrganization } from './pages/manage/Organization'
import { AddSupplierPage, CreateSupplierPage } from './pages/manage/Supplier'
import { EditSupplierPage } from './pages/manage/Supplier'
import { TreeFQDN } from './pages/tree/TreeFQDN'
import { TreeIp } from './pages/tree/TreeIP'
import { TreePort } from './pages/tree/TreePort'
import { TreeCertificate } from './pages/tree/TreeCertificate'
import { TreeTechnology } from './pages/tree/TreeTechnology'
import { TreeWeakness } from './pages/tree/TreeWeakness'
import { TreeVulnerability } from './pages/tree/TreeVulnerability'
import { BrowseFQDNReport, BrowseSupplierReport } from './pages/report/BrowseReport'

const Test = () => {
  const navigate = useNavigate()

  return (
    <>
      <Header/>
      <YStack flex={1} items="center" justify="center">
        <Button onPress={() => navigate("/")}>Excellent</Button>
      </YStack>
    </>
  )
}

export const Router = () => {
  return (
    <TamaguiProvider config={config} defaultTheme="light">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicHome />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/register" element={<Register />}></Route>
          <Route path="manage">
            <Route path="org/create" element={<CreateOrganization />}></Route>
            <Route path="org/:orgId" element={<ManageOrganization tab={undefined} />}></Route>
            <Route path="org/:orgId/dashboard" element={<ManageOrganization tab='tab_dashboard' />}></Route>
            <Route path="org/:orgId/suppliers" element={<ManageOrganization tab='tab_suppliers' />}></Route>
            <Route path="org/:orgId/members" element={<ManageOrganization tab='tab_members' />}></Route>
            <Route path="org/:orgId/edit" element={<ManageOrganization tab='tab_org' />}></Route>
            <Route path="org/:orgId/suppliers/create" element={<CreateSupplierPage />}></Route>
            <Route path="org/:orgId/suppliers/add" element={<AddSupplierPage />}></Route>
            <Route path="supplier/:supplierId" element={<EditSupplierPage />}></Route>
          </Route>
          <Route path="tree">
            <Route path="fqdn/:entityId" element={<TreeFQDN />}></Route>
            <Route path="ip/:entityId" element={<TreeIp />}></Route>
            <Route path="port/:entityId" element={<TreePort />}></Route>
            <Route path="certificate/:entityId" element={<TreeCertificate />}></Route>
            <Route path="technology/:entityId" element={<TreeTechnology />}></Route>
            <Route path="weakness/:entityId" element={<TreeWeakness />}></Route>
            <Route path="vulnerability/:entityId" element={<TreeVulnerability />}></Route>
          </Route>
          <Route path="/reports">
            <Route path="ai/fqdn/:reportId" element={<BrowseFQDNReport />}></Route>
            <Route path="ai/supplier/:reportId" element={<BrowseSupplierReport />}></Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </TamaguiProvider>
  )
}
